import { render, staticRenderFns } from "./dataAssitant.vue?vue&type=template&id=37d1467a"
import script from "./dataAssitant.vue?vue&type=script&lang=js"
export * from "./dataAssitant.vue?vue&type=script&lang=js"
import style0 from "./dataAssitant.vue?vue&type=style&index=0&id=37d1467a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports